{
  "zh-CN": {
    "labels": {
      "loading": "加载中…",
      "true": "是",
      "false": "否",
      "null": "-",
      "presets": {
        "title": "选择图片",
        "filter": "类型",
        "all": "全部",
        "empty": "没有可用的图片。"
      },
      "supporter": {
        "badge": "支持者",
        "tooltip": "本月正在支持 FleetYards.net",
        "none": "非支持者",
        "fleetTierUntil": "舰队等级至 %{date}",
        "fleetTierExpired": "已过期",
        "fleetTierOngoing": "订阅持续期间享有舰队等级",
        "until": "有效期至 %{date}",
        "expiring": "%{date} 到期",
        "ongoing": "定期支持，无结束日期",
        "tierShort": "第 %{tier} 级",
        "tierShortRecurring": "第 %{tier} 级，定期",
        "recurringShort": "定期"
      },
      "destroyedFleets": {
        "discarded": "已丢弃",
        "purged": "已清除"
      },
      "and": "和",
      "hide": "隐藏",
      "show": "显示",
      "only": "仅",
      "description": "描述",
      "unavailable": "不可用",
      "selected": "已选择",
      "actions": "操作",
      "status": "状态",
      "enabled": "已启用",
      "disabled": "已禁用",
      "collapse": "折叠",
      "price": "价格",
      "expand": "展开",
      "distance": "距离",
      "anonymous": "匿名",
      "refreshing": "正在刷新...",
      "toggleNavigation": "切换导航",
      "openInNewWindow": "全屏打开",
      "or": "或",
      "groups": "分组",
      "classifications": "分类",
      "features": {
        "stateOn": "已启用",
        "stateOff": "已禁用",
        "stateConditional": "有条件",
        "openFor": "已开放 %{days} 天",
        "historyEmpty": "尚未记录此功能的任何变更。",
        "historyBy": "由 %{actor}",
        "sources": {
          "admin": "管理后台",
          "self_service": "自助",
          "sync": "部署",
          "console": "控制台",
          "backfill": "回填"
        },
        "selfService": "自助服务",
        "actors": "角色",
        "groups": "群组",
        "noGroups": "此功能没有启用的群组。",
        "noActors": "此功能没有启用的个人角色。",
        "user": "用户",
        "fleet": "舰队",
        "actorType": "角色类型",
        "percentageOfActors": "的角色",
        "percentageOfTime": "的时间",
        "currentState": "当前状态",
        "toggle": "切换",
        "permanent": "长期",
        "tabs": {
          "all": "全部",
          "rollout": "灰度发布",
          "permanent": "长期"
        },
        "settingsIntro": "为您的账户启用或禁用实验性功能。这些功能可能不完整或随时更改。",
        "registryHint": "功能标志在 config/feature_flags.yml 中声明，并在部署时创建。您可以在此控制它们的开放范围。",
        "fleetSettingsIntro": "为整个舰队启用或禁用功能。您在此启用的内容对所有成员可见。",
        "fleetFeature": "舰队功能",
        "fleetFeatureInfo": "在此启用仅对您生效。您舰队的管理员可为整个舰队启用。",
        "toggleForSelf": "仅为自己切换",
        "fleetFeatureGrantedShort": "舰队已启用",
        "fleetFeatureGranted": "您的舰队已为所有成员启用此功能，因此无法在此处关闭。",
        "groupFeatureGrantedShort": "群组已启用",
        "groupFeatureGranted": "您所在的某个群组已启用此功能，因此无法在此处关闭。",
        "groupFeatureGrantedFleet": "该舰队所在的某个群组已启用此功能，因此无法在此处关闭。",
        "managedFeatureShort": "受管理",
        "managedFeature": "此功能已为您的账户启用，无法在此处更改。",
        "managedFeatureFleet": "此功能已为该舰队启用，无法在此处更改。",
        "selfServiceUser": "用户可自行切换",
        "selfServiceFleet": "舰队管理员可切换"
      },
      "oauthApplication": {
        "name": "应用名称",
        "clientId": "客户端 ID",
        "clientSecret": "客户端密钥",
        "redirectUri": "重定向 URI",
        "redirectUriHint": "每行一个 URI。",
        "confidential": "机密",
        "scopes": "权限范围",
        "scopesHint": "如果未选择权限范围，将使用默认范围: %{scopes}",
        "logo": "图标",
        "logoHint": "显示在授权页面上，方便用户辨认你的应用。支持 PNG、JPG、GIF 或 WebP。"
      },
      "rsiRequestLogs": {
        "resolved": "已解决",
        "unresolved": "未解决"
      },
      "imports": {
        "type": "类型",
        "status": "状态",
        "version": "版本",
        "startedAt": "开始于",
        "finishedAt": "完成于",
        "failedAt": "失败于",
        "info": "信息",
        "input": "输入",
        "output": "输出",
        "importData": "导入数据",
        "file": "已导入文件",
        "requestedBy": "请求者",
        "adminUser": "管理员用户",
        "user": "用户",
        "includeSystem": "包含系统",
        "systemRequester": "系统",
        "statuses": {
          "created": "排队中",
          "started": "运行中",
          "finished": "已完成",
          "failed": "已失败",
          "cancelled": "已取消"
        },
        "intro": "你运行过的所有机库导入和 RSI 同步，最新的在前。",
        "targetGroupHint": "选择一个机库分组，所有导入的舰船都会归入其中。留空则使用文件中指定的分组。",
        "types": {
          "Imports::HangarImport": "机库导入",
          "Imports::HangarSync": "RSI 机库同步"
        },
        "summary": {
          "imported": "已导入",
          "missing": "未找到",
          "found": "已匹配"
        },
        "formatHint": "支持两种文件格式：",
        "formats": {
          "fleetyards": "FleetYards 机库导出文件 —— 使用导出按钮即可生成。",
          "hangarXplor": "hangarXPLOR 导出文件。"
        },
        "details": {
          "imported": "已添加",
          "found": "已匹配",
          "movedToWanted": "已移至愿望单",
          "deleted": "已删除",
          "grouped": "已归入分组",
          "unchanged": "保持不变",
          "missing": "未找到的舰船",
          "missingComponents": "未找到的组件",
          "missingUpgrades": "未找到的升级"
        },
        "noDetails": "本次运行未记录详情。"
      },
      "oauthApplications": {
        "settingsIntro": "管理您的 OAuth 应用。这些应用可以代表用户访问 FleetYards API。",
        "name": "应用名称",
        "redirectUri": "重定向 URI",
        "confidential": "机密",
        "clientId": "客户端 ID",
        "clientSecret": "客户端密钥",
        "scopes": "权限范围",
        "defaultScopes": "默认权限范围",
        "confidentialShort": "机密",
        "publicShort": "公开",
        "logo": "图标",
        "state": "状态",
        "rejectionReason": "拒绝原因",
        "statePending": "等待审核",
        "stateApproved": "已批准",
        "stateRejected": "已拒绝",
        "reviewedBy": "审核人",
        "owner": "注册者"
      },
      "fleetInviteToken": "舰队邀请",
      "inviteToken": "邀请码",
      "scDataVersion": "补丁版本",
      "title": "标题",
      "createdAt": "创建于",
      "updatedAt": "更新于",
      "addToHangar": "添加到机库",
      "home": {
        "search": "搜索飞船..."
      },
      "shop": {
        "sellPrice": "出售价格",
        "buyPrice": "购买价格"
      },
      "shopCommodity": {
        "item": "物品",
        "shop": "商店",
        "buyPrices": "买入价格",
        "rentalPrices": "租赁价格",
        "confirmed": "已确认?",
        "prices": {
          "label": "价格",
          "sellPrice": "售价",
          "buyPrice": "买入价"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "%{year} 新飞船",
          "totalShips": "总飞船数",
          "totalMembers": "总成员数",
          "vehicles": "机库飞船",
          "wishlists": "愿望清单飞船",
          "shipOfTheMonth": "月度飞船"
        },
        "modelsByClassification": "Ships by Classification",
        "modelsBySize": "Ships by Size",
        "vehiclesByModel": "Ships by Model (Top %{limit})",
        "modelsPerMonth": "Ships per Month",
        "modelsByManufacturer": "Ships by Manufacturer",
        "modelsByProductionStatus": "Ships by Production Status",
        "vehiclesPerMonth": "每月机库飞船",
        "topVehiclesByModel": "前 10 机库飞船",
        "shipsOfTheMonth": "月度飞船",
        "trendingShips": "浏览最多的飞船（30 天）",
        "wishlistByModel": "最受期待的飞船",
        "wishToOwnRatio": "每 100 艘拥有对应的期待数",
        "topPaints": "最受欢迎的涂装",
        "paintedVehicles": "已涂装飞船",
        "pledgePriceChanges": "现金购买价变动（12 个月）",
        "mostWishlisted": "本月最受期待的飞船",
        "patchChanges": "本次更新改动最大的飞船",
        "crewDeficit": "船员缺口",
        "crewSurplus": "船员盈余",
        "membersByRole": "按角色分组成员",
        "csv": {
          "metric": "指标",
          "value": "数值",
          "count": "数量"
        }
      },
      "roadmap": {
        "releases": "发布",
        "released": "已发布",
        "lastVersion": {
          "active": {
            "false": "条目已从路线图移除",
            "true": "条目已重新添加到路线图"
          },
          "released": "Item was released to PU",
          "release": "Item moved from release %{old} to %{new}"
        },
        "stories": {
          "one": "%{count} Story",
          "other": "%{count} Stories"
        },
        "tasks": {
          "one": "of %{count} Task",
          "other": "of %{count} Tasks"
        },
        "ships": {
          "one": "%{count} Ship",
          "other": "%{count} Ships"
        }
      },
      "unknown": "未知",
      "none": "-",
      "notAvailable": "N/A",
      "not-available": "N/A",
      "name": "名称",
      "homepage": "主页",
      "discord": "Discord 服务器",
      "youtube": "Youtube 频道",
      "twitch": "Twitch 频道",
      "guilded": "Guilded 服务器",
      "3dView": "3D",
      "3dMap": "Map",
      "filter": "筛选",
      "taxExcluded": "不含增值税",
      "hangar": "机库",
      "public": "公开",
      "hangarStats": "统计",
      "wishlist": "愿望清单",
      "fleetchart": "舰队图表",
      "fleetchartApp": {
        "screenHeight": "屏幕高度",
        "viewpoint": "视角",
        "screenHeightOptions": {
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "side": "侧面",
          "top": "顶部",
          "angled": "斜角",
          "front": "正面"
        },
        "gridSize": "每格 %{size} 米",
        "mode": "模式",
        "modeOptions": {
          "classic": "经典",
          "panzoom": "v2"
        }
      },
      "fleetStats": "统计",
      "hangarMetrics": {
        "total": "总计",
        "totalMoney": "Money Value",
        "totalCredits": "Credits",
        "totalIngameValue": "机库 aUEC 价值",
        "totalMinCrew": "最少船员",
        "totalMaxCrew": "最多船员",
        "totalCargo": "总货物",
        "largestShip": "最大飞船",
        "smallestShip": "最小飞船",
        "averagePledgePrice": "平均质押价格",
        "flightReady": "可飞行",
        "uniqueModels": "独特型号",
        "manufacturerCount": "制造商",
        "missingClassifications": "缺失角色",
        "wishlistTotalMoney": "愿望清单质押价值",
        "wishlistTotalCredits": "愿望清单游戏内价值"
      },
      "selectModel": "选择飞船",
      "findModel": "输入以查找飞船",
      "find": "输入以搜索",
      "selectUser": "选择用户",
      "findUser": "输入以搜索用户",
      "selectAdminUser": "选择管理员用户",
      "selectFleet": "选择舰队",
      "findFleet": "输入以搜索舰队",
      "compare": {
        "removeModel": "移除飞船",
        "addModel": {
          "nullablePrompt": "添加飞船"
        },
        "enough": "Don't you think 8 Ships are enough? ;)",
        "shipCount": {
          "one": "%{count} 飞船",
          "other": "%{count} 飞船"
        },
        "containersOfSize": "%{size} SCU 集装箱",
        "armorHp": "装甲 HP",
        "fuelAndQuantum": "燃料与量子",
        "weaponPoolSize": "武器能量池",
        "crossSection": {
          "x": "横截面 X",
          "y": "横截面 Y",
          "z": "横截面 Z"
        },
        "useAsBaseline": "用作基准",
        "baseline": "基准",
        "differencesOnly": "仅显示差异",
        "compareToBaseline": "与基准比较",
        "loadoutBySlot": "按挂点分组的配置",
        "slots": {
          "guns": "主炮",
          "turrets": "炮塔",
          "missiles": "导弹",
          "shields": "护盾发生器",
          "powerPlants": "发电机",
          "coolers": "散热器",
          "quantumDrives": "量子引擎",
          "thrusters": "主推进器",
          "countermeasures": "干扰弹"
        },
        "legend": {
          "best": "本行最佳",
          "worst": "最差",
          "share": "占本行最佳的比例",
          "better": "优于基准",
          "worse": "落后于基准"
        },
        "selectShips": "选择飞船"
      },
      "au": "AU",
      "uec": "aUEC",
      "sell": "卖出",
      "buy": "买入",
      "yourFlagship": "您的旗舰",
      "flagship": "旗舰",
      "fleet": {
        "index": "舰队",
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "舰队",
        "fid": "舰队 ID",
        "name": "名称",
        "logo": "标志",
        "rsiSid": "SID",
        "description": "描述",
        "public": "公开舰队视图",
        "publicFleet": "公开舰队",
        "publicStats": "公开统计",
        "publicFleetStats": "公开舰队统计",
        "discord": {
          "url": "Discord 服务器",
          "hint": "连接一个 Discord 服务器，将活动同步为原生的预定活动。成员可以在 Discord 中回复出席，报名会同步回 Fleetyards。",
          "guildId": "Discord 服务器 ID",
          "channelId": "语音频道 ID（可选）",
          "webhookUrl": "公告 Webhook URL（可选）",
          "installBotHint": "在新标签页中打开 Discord 安装页面 — 选择您希望同步活动的服务器。",
          "statusOk": "已连接到 %{name}",
          "statusCodes": {
            "missing_token": "服务器端未配置 Fleetyards 机器人。请联系管理员。",
            "missing_guild": "请先输入 Discord 服务器 ID。",
            "invalid_token": "机器人令牌无效。请联系管理员。",
            "bot_not_in_guild": "机器人不在该服务器中。请使用安装链接将其添加进去。",
            "guild_not_found": "Discord 无法识别此服务器 ID。请仔细核对该值。",
            "discord_error": "Discord 返回了意外的错误。",
            "request_failed": "无法连接到 Fleetyards。请重试。"
          }
        },
        "guilded": "Guilded 服务器",
        "homepage": "主页",
        "twitch": "Twitch 频道",
        "youtube": "Youtube 频道",
        "backgroundImage": "背景图片",
        "ts": "Teamspeak 服务器",
        "awaitingConfirmation": "等待舰队确认",
        "members": {
          "primary": "主舰队?",
          "shipsFilter": {
            "label": "哪些飞船应该添加到舰队?",
            "nullablePrompt": "未选择选项",
            "field": "飞船选择",
            "values": {
              "all": "所有飞船",
              "hangar_group": "指定机库群组中的所有飞船",
              "hide": "无飞船"
            }
          },
          "hangarGroupId": {
            "field": "机库群组",
            "label": "指定机库群组",
            "nullablePrompt": "未选择群组"
          },
          "blueprintsFilter": {
            "label": "哪些蓝图应与舰队共享？",
            "nullablePrompt": "未选择任何选项",
            "field": "蓝图选择",
            "values": {
              "all": "我拥有的全部蓝图",
              "hide": "不共享蓝图"
            }
          },
          "total": "总计: %{count}",
          "joined": "加入于",
          "invited": "已邀请",
          "invitedAt": "邀请/请求于",
          "requested": "已请求加入",
          "declined": "已拒绝",
          "pending": "待处理的邀请与请求",
          "accepted": "成员",
          "role": "角色",
          "roles": {
            "admin": "管理员",
            "officer": "军官",
            "member": "成员"
          },
          "contact": "Contact",
          "spectrumDm": "Message on Spectrum",
          "discordContact": "Discord",
          "views": {
            "members": "成员",
            "invites": "邀请"
          }
        },
        "roles": {
          "permanent": "永久",
          "privilegeGroups": {
            "fleet": "舰队",
            "memberships": "成员",
            "invites": "邀请",
            "vehicles": "载具",
            "blueprints": "蓝图",
            "roles": "角色",
            "inventories": "库存",
            "missions": "任务",
            "events": "活动",
            "allies": "盟友",
            "contracts": "合约",
            "payouts": "分账",
            "notifications": "通知"
          },
          "privileges": {
            "fleet:update": "更新舰队",
            "fleet:update:images": "更新图片",
            "fleet:update:description": "更新描述",
            "fleet:delete": "删除舰队",
            "fleet:manage": "管理舰队",
            "fleet:memberships:read": "查看成员",
            "fleet:memberships:create": "邀请成员",
            "fleet:memberships:update": "更新成员",
            "fleet:memberships:delete": "移除成员",
            "fleet:memberships:manage": "管理成员",
            "fleet:invites:read": "查看邀请",
            "fleet:invites:create": "创建邀请",
            "fleet:invites:update": "更新邀请",
            "fleet:invites:delete": "删除邀请",
            "fleet:invites:manage": "管理邀请",
            "fleet:vehicles:read": "查看载具",
            "fleet:vehicles:create": "添加载具",
            "fleet:vehicles:update": "更新载具",
            "fleet:vehicles:delete": "移除载具",
            "fleet:vehicles:manage": "管理载具",
            "fleet:blueprints:read": "查看蓝图",
            "fleet:roles:read": "查看角色",
            "fleet:roles:create": "创建角色",
            "fleet:roles:update": "更新角色",
            "fleet:roles:delete": "删除角色",
            "fleet:roles:manage": "管理角色",
            "fleet:inventories:read": "查看库存",
            "fleet:inventories:create": "创建库存",
            "fleet:inventories:update": "更新库存",
            "fleet:inventories:delete": "删除库存",
            "fleet:inventories:manage": "管理库存",
            "fleet:missions:read": "查看任务",
            "fleet:missions:create": "创建任务",
            "fleet:missions:update": "更新任务",
            "fleet:missions:delete": "删除任务",
            "fleet:missions:manage": "管理任务",
            "fleet:events:read": "查看活动",
            "fleet:events:create": "创建活动",
            "fleet:events:update": "更新活动",
            "fleet:events:delete": "删除活动",
            "fleet:events:manage": "管理活动",
            "fleet:allies:read": "查看盟友",
            "fleet:allies:create": "添加盟友",
            "fleet:allies:delete": "移除盟友",
            "fleet:allies:manage": "管理盟友",
            "fleet:contracts:read": "查看合约",
            "fleet:contracts:create": "创建合约",
            "fleet:contracts:update": "更新合约",
            "fleet:contracts:delete": "删除合约",
            "fleet:contracts:manage": "管理合约",
            "fleet:payouts:read": "查看分账",
            "fleet:payouts:create": "记录分账",
            "fleet:payouts:update": "更新分账",
            "fleet:payouts:delete": "删除分账",
            "fleet:payouts:manage": "管理分账",
            "fleet:notifications:manage": "管理通知设置"
          },
          "name": "名称",
          "rank": "等级"
        },
        "inviteUrls": {
          "noExpiration": "Never expires",
          "used": "已使用 %{count} 次",
          "usedOfLimit": "已使用 %{count} / %{limit}",
          "expiresIn": "Expires in %{time}",
          "expired": "Expired",
          "expiresAfterOptions": {
            "infinite": "Never",
            "30_minutes": "30 minutes",
            "1_hour": "1 hour",
            "6_hours": "6 hours",
            "12_hours": "12 hours",
            "1_day": "1 天",
            "7_days": "7 days"
          },
          "limitOptions": {
            "1": "1 use",
            "5": "5 uses",
            "10": "10 uses",
            "25": "25 uses",
            "50": "50 uses",
            "100": "100 uses",
            "infinite": "No limit"
          }
        },
        "calendarSubscription": {
          "intro": "生成一个私有链接，成员可以用它在日历应用（Apple 日历、Google 日历、Outlook）中订阅本舰队的活动。",
          "howTo": "将上面的链接分享给您的成员。他们把它粘贴到日历应用中（“订阅日历”或“通过 URL 添加”）。该链接是私有的 — 任何拿到它的人都能看到本舰队的活动。"
        },
        "notifications": {
          "inAppHint": "选择哪些活动状态变更会以应用内通知的形式推送给舰队成员。",
          "events": {
            "fleet_event": {
              "published": "活动已发布",
              "locked": "报名已锁定",
              "unlocked": "报名已重新开放",
              "starting_soon": "活动即将开始",
              "started": "活动已开始",
              "completed": "活动已完成",
              "cancelled": "活动已取消",
              "archived": "活动已归档",
              "destroyed": "活动已删除"
            },
            "fleet_event_signup": {
              "created": "新增报名",
              "withdrawn": "报名已取消"
            }
          }
        },
        "inventories": {
          "name": "名称",
          "description": "描述",
          "location": "位置",
          "visibility": "可见性",
          "manager": "管理者",
          "itemsCount": "条目数",
          "visibilities": {
            "members_only": "仅成员",
            "officers_only": "仅军官"
          }
        },
        "allies": "盟友可见舰船",
        "alliesStats": "盟友可见统计",
        "alliesMembers": "盟友可见成员列表",
        "contractCovers": {
          "transport": "运送封面图",
          "procurement": "采购封面图",
          "crafting": "制造封面图"
        }
      },
      "hangarGroup": {
        "name": "名称",
        "color": "颜色",
        "sort": "排序",
        "public": "在公开机库显示?"
      },
      "source": "来源",
      "loadout": {
        "namePlaceholder": "配置名称...",
        "urlPlaceholder": "粘贴 erkul.games 或 spviewer.eu 的配置链接...",
        "empty": "暂无配置。创建一个以开始使用。",
        "active": "使用中",
        "activate": "设为使用中",
        "planOn": "在此规划您的配置"
      },
      "model": {
        "hidden": "隐藏?",
        "active": "活跃?",
        "inGame": "已实装?",
        "adiMap": "ADI 地图?",
        "ground": "地面载具?",
        "productionNote": "生产备注",
        "rsiId": "RSI ID",
        "length": "长度",
        "beam": "宽度",
        "height": "高度",
        "scKey": "SC Key",
        "price": "价格",
        "pledgePrice": "质押价格",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "质量",
        "minCrew": "最少船员",
        "maxCrew": "最多船员",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "最大速度",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "货物",
        "cargoHolds": "货舱",
        "hydrogenFuelTankSize": "氢燃料箱大小",
        "hydrogenFuelTanks": "氢燃料箱",
        "quantumFuelTankSize": "量子燃料箱大小",
        "quantumFuelTanks": "量子燃料箱",
        "externalFuelTanks": "外挂燃料箱",
        "externalFuelTanksTotal": "总容量",
        "externalFuelTanksCount": "挂舱",
        "refuelBoom": "加油臂",
        "refuelBoomArm": "臂",
        "refuelBoomNozzle": "喷嘴",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "偏航（增强）",
        "pitchBoosted": "俯仰（增强）",
        "rollBoosted": "翻滚（增强）",
        "variants": "变体",
        "manufacturer": "制造商",
        "loaners": "借用船",
        "paints": "涂装",
        "modules": "模块",
        "modulePackages": "模块包",
        "upgrades": "升级套件",
        "brochure": "手册",
        "holo": "Holo",
        "angledView": "斜视图",
        "angledViewColored": "斜视图（彩色）",
        "sideView": "侧视图",
        "sideViewColored": "侧视图（彩色）",
        "frontView": "前视图",
        "frontViewColored": "前视图（彩色）",
        "topView": "俯视图",
        "topViewColored": "俯视图（彩色）",
        "onSale": "在售",
        "playerOwnable": "玩家可拥有?",
        "ingameOnly": "仅游戏内获取",
        "salesPage": "销售页面",
        "addons": "模块与升级套件",
        "storeImage": "商店图片",
        "wiki": "Star Citizen Wiki",
        "crewPositions": "船员岗位",
        "needsCuration": "需人工校订",
        "curatedPosition": "人工校订的岗位",
        "baseModel": "基础型号",
        "fleetchartOffsetLength": "舰队图表长度偏移",
        "fleetchartOffsetBeam": "舰队图表宽度偏移",
        "extendedLength": "展开长度",
        "extendedBeam": "展开宽度",
        "extendedHeight": "展开高度",
        "extendedFleetchartOffsetLength": "展开舰队图偏移长度",
        "extendedFleetchartOffsetBeam": "展开舰队图偏移宽度",
        "defaultHolo": "默认全息图",
        "extendedHolo": "展开全息图",
        "extendedTopView": "展开俯视图",
        "extendedTopViewColored": "展开俯视图（涂装）",
        "extendedSideView": "展开侧视图",
        "extendedSideViewColored": "展开侧视图（涂装）",
        "extendedFrontView": "展开正视图",
        "extendedFrontViewColored": "展开正视图（涂装）",
        "extendedAngledView": "展开斜视图",
        "extendedAngledViewColored": "展开斜视图（涂装）",
        "landedHolo": "着陆全息图",
        "landedTopView": "着陆俯视图",
        "landedSideView": "着陆侧视图",
        "landedFrontView": "着陆正视图",
        "landedAngledView": "着陆斜视图",
        "landedTopViewColored": "着陆俯视图（涂装）",
        "landedSideViewColored": "着陆侧视图（涂装）",
        "landedFrontViewColored": "着陆正视图（涂装）",
        "landedAngledViewColored": "着陆斜视图（涂装）",
        "state": {
          "flight": "飞行中",
          "extended": "展开",
          "landed": "着陆"
        },
        "productionStatus": {
          "in-production": "生产中",
          "in-concept": "概念阶段",
          "ready": "机库就绪",
          "flight-ready": "可飞行",
          "announced": "已公布"
        },
        "carriedBy": "可被搭载于",
        "landedLength": "着陆长度",
        "landedBeam": "着陆宽度",
        "landedHeight": "着陆高度",
        "landedFleetchartOffsetLength": "着陆舰队图长度偏移",
        "landedFleetchartOffsetBeam": "着陆舰队图宽度偏移"
      },
      "models": {
        "extraColumns": "列",
        "table": {
          "columns": {
            "storeImage": "图片",
            "storeImageWide": "宽图片",
            "rsiStoreImage": "RSI 图片",
            "rsiStoreImageWide": "宽 RSI 图片",
            "angledView": "3D 图片",
            "angledViewWide": "宽 3D 图片",
            "rsiId": "RSI ID",
            "hidden": "隐藏",
            "active": "活跃",
            "createdAt": "创建于",
            "updatedAt": "更新于",
            "manufacturerName": "制造商",
            "length": "长度",
            "beam": "宽度",
            "height": "高度",
            "mass": "质量",
            "cargo": "货物",
            "quantumFuelTankSize": "量子燃料",
            "hydrogenFuelTankSize": "氢燃料",
            "minCrew": "船员",
            "maxCrew": "最多船员",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "最大速度",
            "groundMaxSpeed": "地面速度",
            "focus": "定位",
            "productionStatus": "生产状态",
            "price": "价格",
            "pledgePrice": "质押价格"
          }
        }
      },
      "metrics": {
        "info": "信息",
        "levels": "等级",
        "views": "视图",
        "base": "基础",
        "crew": "船员",
        "speed": "速度",
        "cargo": "货物",
        "combat": "战斗",
        "hardpoints": "挂载点"
      },
      "flight": {
        "title": "飞行",
        "scm": "战斗巡航",
        "nav": "巡航",
        "boost": "加速",
        "boostSub": "加力燃烧",
        "reverse": "倒车",
        "maneuverability": "机动性",
        "fuel": "燃料",
        "fuelHydrogen": "氢",
        "fuelQuantum": "量子",
        "hint": "加速后的操控表现随引擎能量档位变化；引擎未通电时全部为零。"
      },
      "base": {
        "price": "价格",
        "priceInGame": "游戏内",
        "pricePledge": "质押",
        "availability": "供应情况"
      },
      "availability": {
        "title": "供应情况",
        "buy": "购买",
        "rent": "租赁",
        "sell": "出售",
        "cheapest": {
          "buy": "最低售价",
          "rent": "最低租金"
        },
        "bestSale": "最高收购价",
        "allLocations": "全部地点",
        "locations": {
          "one": "%{count} 个地点",
          "other": "%{count} 个地点"
        },
        "empty": "没有已知的购买或租赁地点。",
        "timeRange": {
          "1-day": "1 天",
          "3-days": "3 天",
          "7-days": "7 天",
          "30-days": "30 天"
        }
      },
      "cargo": {
        "title": "货物",
        "holdsSub": "分布于 %{count} 个货舱",
        "maxContainerSub": "可容纳的最大箱体",
        "containers": "集装箱容量",
        "hint": "每种尺寸的集装箱在货物网格中可容纳的最大数量；进度条显示其占总容量的比例。"
      },
      "fuelTanks": {
        "capacitySub": "分布于 %{count} 个挂舱",
        "podsSub": "外部挂点",
        "components": "挂舱类型",
        "perPod": "每个挂舱",
        "hint": "挂载在外部挂点上的燃料舱所携带的燃料；进度条显示每种类型占总容量的比例。"
      },
      "refuelBoom": {
        "fuelFlowSub": "氢燃料传输",
        "quantumFlowSub": "量子燃料传输",
        "captureRadiusSub": "对接容差",
        "equipment": "装备",
        "hint": "加油臂的传输速率及其喷嘴的对接容差。"
      },
      "combat": {
        "title": "战斗",
        "dps": "爆发 DPS",
        "dpsSub": "%{count} 件武器",
        "sustained": "持续 DPS",
        "sustainedSub": "计入能量回复与过热",
        "alpha": "齐射伤害",
        "alphaSub": "每次齐射",
        "weapons": "武器",
        "missileDamage": "导弹伤害",
        "composition": "伤害构成",
        "damagePhysical": "物理",
        "damageEnergy": "能量",
        "damageDistortion": "扭曲",
        "damageThermal": "热能",
        "hint": "数据来自默认配置的 DPS。持续 DPS 计入每件武器的能量池回复和过热循环。不含导弹。"
      },
      "power": {
        "title": "能量分配",
        "scm": "SCM",
        "nav": "NAV",
        "reset": "重置",
        "auto": "自动",
        "aimAssist": "瞄准辅助",
        "cooling": "散热",
        "ir": "IR",
        "em": "EM",
        "cs": "CS",
        "csAxisHint": "点击切换轴（x / y / z）",
        "segmentsUsed": "%{used} / %{total} 格",
        "hint": "在各系统间分配能量。武器的持续 DPS 随其获得的能量变化；其余部分会自动平衡。",
        "families": {
          "weapon": "武器",
          "shield": "护盾",
          "engine": "引擎",
          "radar": "雷达",
          "coolers": "散热器",
          "qdrive": "量子引擎",
          "qed": "QED",
          "emp": "EMP",
          "lifeSupport": "生命维持",
          "miningLaser": "采矿激光",
          "salvage": "回收",
          "tractorBeam": "牵引光束",
          "towingbeam": "拖曳光束"
        }
      },
      "defense": {
        "title": "防御",
        "shieldHp": "护盾 HP",
        "shieldHpSub": "%{count} 台发生器",
        "shieldRegen": "回复",
        "shieldResistances": "抗性",
        "shieldAbsorption": "吸收",
        "armor": "装甲",
        "deflection": "偏转",
        "armorReduction": "伤害减免",
        "armorSelfResistance": "自身抗性",
        "armorSignature": "信号特征",
        "damageType": {
          "physical": "物理",
          "energy": "能量",
          "distortion": "扭曲",
          "thermal": "热能"
        },
        "signature": {
          "electromagnetic": "EM",
          "infrared": "IR",
          "crossSection": "CS"
        },
        "hint": "护盾与装甲数值来自默认配置。吸收率低于 100% 表示该伤害类型在护盾仍在时就能打到船体。",
        "openDeflectionCheck": "偏转检测"
      },
      "deflectionCheck": {
        "title": "偏转检测",
        "intro": "— 哪些武器能击穿它的防御?",
        "noArmor": "这艘飞船没有装甲，因此不会发生偏转。",
        "allSizes": "全部",
        "deflected": "被偏转",
        "pierce": "可击穿",
        "weapon": "武器",
        "boundary": "偏转界限",
        "alpha": "单发伤害",
        "threshold": "已越过阈值",
        "absorbed": "被吸收",
        "versus": "对比",
        "hoverHint": "将鼠标悬停在武器上可查看按伤害类型的细分。",
        "note": "单发伤害按每颗弹丸计算，且在护盾吸收之后比较 — 只要某一伤害类型超过偏转值，该武器即可击穿。被护盾完全吸收的类型永远到不了装甲，因此列为被吸收而非被偏转: 挡下它的是护盾，不是船体。护盾吸收率会根据护盾耐久在其公布的最小-最大区间内插值，装甲偏转值则随装甲耐久线性变化。激光束不在统计之内 — 它造成持续伤害，没有可供比较的单发伤害。",
        "margin": "余量",
        "reachesArmor": "可达装甲",
        "stoppedByShields": "护盾吸收",
        "verdict": {
          "absorbed": "已吸收",
          "deflected": "已偏转",
          "pierces": "已击穿"
        },
        "shieldHealth": "护盾耐久",
        "armorHealth": "装甲耐久",
        "absorb": "吸收",
        "defl": "偏转",
        "type": "类型",
        "size": "尺寸"
      },
      "hull": {
        "category": {
          "vital": "关键",
          "secondary": "次要",
          "breakable": "可破坏",
          "subpart": "子部件",
          "cosmetic": "装饰"
        },
        "composition": "船体构成",
        "door": "舱门",
        "doors": "舱门",
        "doorsNote": "可破坏的内部舱门属于独立区域 — 它们有各自的耐久度，不计入船体 HP。",
        "doorsSub": "%{count} 个可破坏",
        "hint": "船体 HP 是所有部件耐久度的总和。",
        "hullHp": "船体 HP",
        "hullHpSub": "所有部件合计",
        "integrity": "船体完整度",
        "noHp": "无 HP",
        "parts": "船体部件",
        "partsNote": "部件按耐久度排序；装饰性部件（舱门、梯子、襟翼）本身没有耐久度。游戏文件未提供父子层级关系，因此这里是平铺列表而非结构树。",
        "partsSub": "分布于 %{count} 个类别",
        "partsTree": "部件 · damageMax",
        "showParts": "显示船体部件",
        "title": "船体",
        "totalHp": "船体总 HP"
      },
      "manufacturer": {
        "longName": "全名",
        "code": "代码",
        "logo": "标志",
        "logoOverridden": "标识（已覆盖）",
        "icon": "图标（游戏文件）",
        "iconOverridden": "图标（已覆盖）",
        "scRef": "SC Ref"
      },
      "announcement": {
        "title": "标题",
        "body": "正文",
        "discordParts": "Discord 消息",
        "socialParts": "社交平台帖子",
        "link": "链接",
        "notifyUsers": "应用内通知",
        "postDiscord": "Discord 更新频道",
        "postBluesky": "Bluesky",
        "postX": "X.com",
        "schedule": "定时发送",
        "publishAt": "发送时间"
      },
      "fundingGoal": {
        "title": "标题",
        "description": "描述",
        "amount": "金额",
        "currency": "货币",
        "effectiveFrom": "生效日期",
        "endedAt": "结束于"
      },
      "supporterContribution": {
        "name": "支持者名称",
        "user": "关联账户",
        "amount": "金额",
        "currency": "货币",
        "anonymous": "匿名",
        "recurring": "周期性",
        "startedAt": "开始于",
        "endedAt": "结束于",
        "payerEmail": "付款人邮箱",
        "claimKey": "支持者令牌",
        "linkedVia": "关联方式",
        "source": "来源",
        "note": "内部备注",
        "stats": {
          "total": "总计",
          "count": "捐助数",
          "currentMonth": "本月",
          "currentMonthCount": "%{count} 笔捐助",
          "recurringCount": "周期性",
          "anonymousCount": "匿名"
        },
        "chart": {
          "contributions": "捐助",
          "goal": "目标"
        }
      },
      "itemPrice": {
        "price": "价格",
        "location": "位置",
        "locationUrl": "位置 URL"
      },
      "video": {
        "url": "URL",
        "videoType": "类型"
      },
      "modelModule": {
        "name": "名称",
        "description": "描述",
        "price": "价格",
        "pledgePrice": "承诺价格",
        "productionStatus": "生产状态",
        "scKey": "SC Key",
        "storeImage": "商店图片",
        "active": "激活？",
        "hidden": "隐藏？"
      },
      "dockAddition": {
        "model": "飞船",
        "hint": "该泊位可容纳但其类别未涵盖的飞船。",
        "empty": "已指定的飞船"
      },
      "dockCapacity": {
        "ladder": "等级序列",
        "size": "类别",
        "quantity": "数量",
        "display": "作为标签显示",
        "hint": "该泊位的用途。各条目为互选方案，而非累加。",
        "empty": "容量条目"
      },
      "dockCapacityLadders": {
        "ship": "飞船",
        "vehicle": "车辆"
      },
      "vehicleSizes": {
        "extra_extra_small": "超超小型 (XXS)",
        "extra_small": "超小型 (XS)",
        "small": "小型 (S)",
        "medium": "中型 (M)",
        "large": "大型 (L)",
        "extra_large": "超大型 (XL)",
        "extra_extra_large": "超超大型 (XXL)"
      },
      "dock": {
        "name": "名称",
        "dockType": "停靠类型",
        "shipSize": "飞船尺寸",
        "access": "进入方式",
        "length": "长度",
        "beam": "宽度",
        "height": "高度",
        "unmeasured": "未测量"
      },
      "modelPosition": {
        "name": "名称",
        "positionType": "岗位类型",
        "source": "来源",
        "position": "排序",
        "types": {
          "pilot": "飞行员",
          "copilot": "副驾驶",
          "turret_gunner": "炮塔射手",
          "engineer": "工程师",
          "gunner": "射手",
          "loadmaster": "装载员",
          "passenger": "乘客",
          "operator": "操作员",
          "custom": "自定义"
        }
      },
      "modelUpgrade": {
        "name": "名称",
        "description": "描述",
        "pledgePrice": "质押价格",
        "active": "活跃?",
        "hidden": "隐藏?"
      },
      "modelModulePackage": {
        "name": "名称",
        "description": "描述",
        "pledgePrice": "质押价格",
        "modules": "模块",
        "active": "活跃?",
        "hidden": "隐藏?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "旋转 (°)"
      },
      "modelLoaner": {
        "hidden": "隐藏?",
        "loanerModel": "借用型号"
      },
      "modelSnubCraft": {
        "snubCraft": "舰载小艇"
      },
      "modelPaint": {
        "hidden": "隐藏?",
        "active": "活跃?",
        "onSale": "在售",
        "pledgePrice": "质押价格",
        "productionStatus": "生产状态",
        "productionNote": "生产备注",
        "copyHint": "选择要将此涂装复制到的目标飞船。复制过程中不会修改涂装数据。",
        "bulkCopyHint": "选择要将这 %{count} 个涂装复制到的目标飞船。复制过程中不会修改涂装数据。",
        "copySameModel": "目标飞船必须与源飞船不同。"
      },
      "component": {
        "availability": {
          "retired": "价格只针对目录当前所在的版本记录，而该部件不在其中。",
          "craftedOnly": "没有终端出售此物品——它由下方的配方制造。",
          "none": "没有终端买卖此物品。"
        },
        "notRecordedYet": "仅从开始记录之日起统计，因此部件可能尚无记录。",
        "size": "Size: %{size}",
        "grade": "等级",
        "hidden": "隐藏?",
        "componentClass": "组件类别",
        "componentType": "组件类型",
        "componentSubType": "组件子类型",
        "itemType": "物品类型",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image",
        "itemClass": "类别",
        "category": "分类",
        "subType": "子类型",
        "retired": "已不在当前版本中",
        "noMetrics": "该部件没有记录任何数据。"
      },
      "hardpoint": {
        "legend": {
          "headline": "图例",
          "slotTaken": "插槽已占用",
          "slotAvailable": "插槽可用"
        },
        "size": "尺寸",
        "rackSize": "架尺寸",
        "details": "详情",
        "group": "群组",
        "thrusters": {
          "thrust": "推力",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix",
            "Light": "Light"
          }
        },
        "refuelBoom": {
          "captureRadius": "捕获半径",
          "fuelFlowRate": "燃料流速",
          "quantumFuelFlowRate": "量子燃料流速"
        },
        "weapons": {
          "dps": "DPS",
          "burstDps": "爆发 DPS",
          "sustainedDps": "持续 DPS",
          "efficiency": "效率",
          "penetration": "穿透",
          "fireRate": "射速",
          "speed": "速度",
          "range": "射程",
          "ammo": "弹药",
          "ammoCost": "弹药成本",
          "pool": "能量池",
          "maxRegen": "最大回复/秒",
          "costPerShot": "能量/发",
          "heatPerShot": "热量/发",
          "heatPerSecond": "热量/秒",
          "chargeTime": "充能时间",
          "fullDamageRange": "满伤射程",
          "zeroDamageRange": "零伤射程",
          "damagePhysical": "物理",
          "damageEnergy": "能量",
          "damageDistortion": "扭曲",
          "damageThermal": "热能"
        },
        "missiles": {
          "damage": "伤害",
          "speed": "速度",
          "range": "射程",
          "lockRange": "锁定距离",
          "lockTime": "锁定时间",
          "trackingSignal": "追踪"
        },
        "tractorBeams": {
          "maxForce": "最大牵引力",
          "minForce": "最小牵引力",
          "range": "射程",
          "cone": "锥角",
          "tetherBreak": "牵引断开",
          "cargoForce": "货物牵引力",
          "cargoRange": "货物距离",
          "towForce": "拖曳力",
          "towDistance": "拖曳距离",
          "quantumTowMass": "QT 质量上限",
          "rotationSpeed": "旋转",
          "moveSpeed": "移动速度"
        },
        "shields": {
          "hp": "HP",
          "regen": "回复",
          "regenTime": "回复时间",
          "downedRegenDelay": "击穿延迟",
          "damagedRegenDelay": "受损延迟",
          "resistancePhysical": "物理抗性",
          "resistanceEnergy": "能量抗性",
          "resistanceDistortion": "扭曲抗性"
        },
        "coolers": {
          "coolingRate": "冷却速率"
        },
        "powerPlants": {
          "output": "输出",
          "pips": "能量档"
        },
        "quantumDrives": {
          "speed": "速度",
          "range": "航程",
          "fuelConsumption": "消耗",
          "spoolUpTime": "蓄能",
          "cooldownTime": "冷却",
          "splineSpeed": "轨道",
          "accel": "加速度"
        },
        "jumpDrives": {
          "fuelEfficiency": "燃料效率",
          "alignRate": "校准速率",
          "tuneRate": "调谐速率",
          "alignDecay": "校准衰减",
          "tuneDecay": "调谐衰减"
        },
        "radar": {
          "aimAssistRange": "辅助距离",
          "ir": "IR",
          "em": "EM",
          "cs": "CS",
          "rs": "RS"
        },
        "armor": {
          "hp": "HP",
          "physical": "物理",
          "energy": "能量",
          "distortion": "扭曲",
          "thermal": "热能",
          "deflectPhysical": "物理偏转",
          "deflectEnergy": "能量偏转",
          "selfPhysical": "自身物理抗性",
          "selfEnergy": "自身能量抗性"
        },
        "fuelIntakes": {
          "pushRate": "输送速率",
          "minRate": "最小速率"
        },
        "sources": {
          "game_files": "游戏文件",
          "ship_matrix": "Ship Matrix"
        },
        "density": {
          "title": "视图",
          "compact": "紧凑",
          "expanded": "展开"
        },
        "fuelTanks": {
          "hydrogen": "氢燃料箱",
          "quantum": "量子燃料箱"
        },
        "jumpDrive": "跳跃引擎",
        "maxContainerSize": "最大集装箱尺寸",
        "groups": {
          "avionic": "航电",
          "system": "系统",
          "propulsion": "推进",
          "thruster": "推进器",
          "weapon": "武器",
          "defense": "防御",
          "other": "其他",
          "auxiliary": "辅助",
          "seat": "座位",
          "external_fuel_tank": "外挂燃料箱",
          "refuel_boom": "加油臂"
        },
        "types": {
          "radar": "雷达",
          "computers": "电脑",
          "power_plants": "发电机",
          "coolers": "冷却器",
          "shield_generators": "护盾发生器",
          "fuel_intakes": "燃料进气口",
          "fuel_tanks": "燃料箱",
          "quantum_drives": "量子引擎",
          "jump_modules": "跳跃模块",
          "jumpdrive": "跳跃模块",
          "quantum_fuel_tanks": "量子燃料箱",
          "main_thrusters": "主推进器",
          "maneuvering_thrusters": "机动推进器",
          "weapons": "武器",
          "turrets": "炮塔",
          "missiles": "导弹",
          "utility_items": "实用设备",
          "utility": "实用设备",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— 选择模块 —",
        "selectModule": "选择模块",
        "moduleStock": "出厂状态",
        "moduleStockHint": "插槽保持飞船出厂时的状态",
        "categories": {
          "radar": "雷达",
          "armor": "装甲",
          "relay": "中继",
          "countermeasures": "对抗措施",
          "lifesupport": "生命维持",
          "selfdestruct": "自毁",
          "batteries": "电池",
          "computers": "电脑",
          "powerplant": "发电机",
          "cooler": "冷却器",
          "module": "模块",
          "shieldgenerator": "护盾发生器",
          "fuel_intakes": "燃料进气口",
          "fueltanks": "燃料箱",
          "external_fuel_tanks": "外挂燃料箱",
          "refuel_boom": "加油臂",
          "quantumdrive": "量子引擎与跳跃模块",
          "jump_modules": "跳跃模块",
          "jumpdrive": "跳跃模块",
          "quantum_fuel_tanks": "量子燃料箱",
          "main_thrusters": "主推进器",
          "maneuvering_thrusters": "机动推进器",
          "retro_thrusters": "反推推进器",
          "vtol_thrusters": "VTOL 推进器",
          "weapons": "武器",
          "weapon_mounts": "武器挂载",
          "turret": "炮塔",
          "missiles": "导弹",
          "missile_racks": "导弹架",
          "utility_items": "实用设备",
          "utility": "实用设备",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "打捞填充站",
          "cargogrid": "货物网格",
          "seat": "座位",
          "thrusters": "推进器",
          "bombcompartments": "炸弹舱"
        },
        "name": "名称",
        "category": "分类",
        "source": "来源",
        "powerConsumption": "功率消耗",
        "powerMinimumFraction": "待机功耗",
        "signatureEm": "电磁信号",
        "signatureIr": "红外信号",
        "utility": {
          "capacity": "容量"
        },
        "selfDestruct": {
          "damage": "伤害",
          "radius": "爆炸半径",
          "time": "引爆延时"
        },
        "quantumEnforcement": {
          "jammerRange": "干扰范围",
          "pulseRadius": "脉冲半径",
          "chargeTime": "充能时间",
          "cooldownTime": "冷却时间"
        },
        "powerRanges": "功率曲线（低 / 中 / 高）"
      },
      "blank": {
        "propulsion": "没有推进系统",
        "modular": "没有模块",
        "fleetInvites": "没有邀请"
      },
      "user": {
        "rsiHandle": "用户名",
        "rsiHandleVerified": "已通过 Citizen iD 验证",
        "location": "位置",
        "currentSystem": "当前星系",
        "tester": "测试者?",
        "avatar": "头像",
        "unconfirmedEmail": "未确认的邮件",
        "saleNotify": "我希望收到销售通知",
        "publicHangar": "公开机库已启用",
        "publicHangarLoaners": "在公开机库显示借用船提示",
        "publicHangarStats": "公开机库统计已启用",
        "publicWishlist": "公开愿望清单已启用",
        "hideOwner": "为舰队隐藏所有权",
        "tracking": "允许匿名使用情况分析",
        "showOnlineStatus": "显示我的在线状态",
        "onlineStatus": "在线状态",
        "online": "在线",
        "offline": "离线",
        "lastActiveAt": "最后活跃",
        "confirmedAt": "确认于",
        "dateFormat": "日期格式",
        "dateFormats": {
          "dmy_dots": "31.12.2026",
          "dmy_slash": "31/12/2026",
          "mdy_slash": "12/31/2026",
          "ymd_dash": "2026-12-31"
        },
        "friendsHangar": "好友可见机库",
        "friendsHangarStats": "好友可见机库统计",
        "friendsWishlist": "好友可见愿望单"
      },
      "adminUser": {
        "superAdmin": "超级管理员",
        "passwordConfirmation": "确认密码"
      },
      "vehicle": {
        "name": "名称",
        "states": "状态",
        "serial": "序列号",
        "owner": "指挥官",
        "flagship": "旗舰",
        "wanted": "想要",
        "loaner": "借用",
        "bundled": "捆绑",
        "bundledWith": "与 %{parent} 捆绑",
        "public": "公开可见",
        "fullPublic": "公开可见（包括名称）",
        "publicShort": "公开",
        "nameVisible": "公开可见",
        "hidden": "隐藏?",
        "saleNotify": "我希望收到销售通知",
        "hangarGroups": "群组",
        "modelPaintSelect": {
          "nullablePrompt": "选择涂装",
          "label": "涂装"
        },
        "bulkGroupEdit": {
          "hint": "现有群组将被覆盖！"
        },
        "hasLoaners": "借用船",
        "boughtViaSelect": {
          "label": "购买方式"
        }
      },
      "image": {
        "active": "活跃?",
        "background": "用作背景?",
        "caption": "标题",
        "enabled": "已启用?",
        "file": "图片文件",
        "global": "全局?",
        "delete": "删除",
        "start": "开始",
        "cancel": "取消",
        "processing": "处理中...",
        "error": "错误",
        "name": "名称",
        "size": "文件大小",
        "dropzone": "将图片拖放到此处",
        "cancelUpload": "取消上传",
        "startUpload": "开始上传",
        "selectImages": "添加图片...",
        "selectFolder": "添加文件夹..."
      },
      "signup": {
        "link": "还没有账户?",
        "privacyPolicy": "创建 FleetYards 账户即表示您同意我们的"
      },
      "privacyPolicy": "隐私政策",
      "login": "用户名或电子邮件",
      "username": "用户名",
      "twoFactorCode": "两步验证码",
      "confirmationCode": "确认码",
      "email": "电子邮件",
      "avatar": "头像",
      "alreadyRegistered": "已有账户?",
      "password": "密码",
      "passwordConfirmation": "确认密码",
      "rememberMe": "记住我",
      "emptyList": "没有 %{name}",
      "all": "全部",
      "supportUs": "Support FleetYards.net",
      "account": {
        "destroyInfo": "If you want to delete Your Account and remove all your Information from Fleetyards.net and its Services click the Button below. Be aware of that this is a permanent Action and can't be reverted.",
        "calendarSubscription": {
          "intro": "生成一个私有链接，将您已报名的活动添加到个人日历应用（Apple 日历、Google 日历、Outlook）。",
          "howTo": "将该链接粘贴到日历应用的“订阅日历”或“通过 URL 添加”中。任何拿到此链接的人都能看到您已报名的活动 — 请妥善保管。"
        },
        "supporterNomination": {
          "label": "舰队支持",
          "hint": "只要捐赠有效，其成员即可使用舰队功能。你可以在捐赠前选择。",
          "perDonation": "按捐赠设置",
          "perDonationHint": "单笔捐赠可以支持与常用舰队不同的舰队。",
          "fleet": "受支持的舰队"
        },
        "supporterClaimKey": {
          "signedOut": "请登录以获取您的专属支持者密钥。",
          "patreonNote": "通过您的邮箱关联，无需密钥",
          "label": "您的密钥",
          "hint": "将其粘贴到 PayPal、Ko-fi 或 Buy me a coffee 付款的留言中，付款即可与您的账号关联。Patreon 则通过邮箱关联。"
        }
      },
      "filters": {
        "components": {
          "name": "名称",
          "itemType": "物品类型",
          "componentClass": "组件类别",
          "buyPriceGt": "买入价格 >=",
          "buyPriceLt": "买入价格 <=",
          "sellPriceGt": "卖出价格 >=",
          "sellPriceLt": "卖出价格 <=",
          "storeImageBlank": "没有商店图片?",
          "description": "描述",
          "manufacturer": "制造商",
          "category": "分类",
          "subType": "子类型"
        },
        "shops": {
          "name": "名称",
          "type": "类型",
          "model": "飞船",
          "equipment": "装备",
          "component": "组件",
          "commodity": "商品",
          "commodityType": "商品类型"
        },
        "shopCommodities": {
          "commodityType": "商品类型",
          "equipment": "装备",
          "component": "组件",
          "commodity": "商品",
          "model": "飞船",
          "name": "名称"
        },
        "shopItems": {
          "category": "分类",
          "subCategory": "子分类",
          "name": "名称",
          "manufacturer": "制造商"
        },
        "stations": {
          "name": "名称",
          "type": "空间站类型",
          "shops": "商店",
          "docks": "停靠口"
        },
        "vehicles": {
          "name": "Name or Ship name",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "价格 <=",
          "priceGt": "价格 >=",
          "wanted": "想要",
          "hidden": "隐藏",
          "public": "公开",
          "group": "群组",
          "loaner": "借用船",
          "bundled": "捆绑的舰载小艇",
          "boughtVia": "购买方式?"
        },
        "tradeRoutes": {
          "sortBy": "Sort by",
          "sortByValues": {
            "percent": "Max. Percent"
          },
          "origin": "From?",
          "destination": "To?"
        },
        "models": {
          "name": "名称",
          "classification": "分类",
          "focus": "定位",
          "manufacturer": "制造商",
          "onSale": "在售",
          "ingameOnly": "仅游戏内获取",
          "size": "尺寸",
          "dockSize": "停靠尺寸",
          "price": "价格",
          "pledgePrice": "质押价格",
          "productionStatus": "生产状态",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "beamLt": "Beam <=",
          "beamGt": "Beam >=",
          "heightLt": "Height <=",
          "heightGt": "Height >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "价格 <=",
          "priceGt": "价格 >=",
          "willItFit": "Will it Fit?",
          "withCargo": "有货物?",
          "scKeyBlank": "没有 SC Key?",
          "positionsNeedCuration": "岗位需人工校订?",
          "fleetchartImageBlank": "没有舰队图表图片?",
          "holoBlank": "没有 Holo?",
          "frontViewBlank": "没有前视图图片?",
          "topViewColoredBlank": "没有彩色俯视图图片?",
          "vehicleSize": "载具尺寸",
          "dimensionsDrifted": "尺寸与游戏文件不一致",
          "dimensionsMeasuredAtNull": "没有实测尺寸?"
        },
        "modelModules": {
          "name": "名称"
        },
        "manufacturers": {
          "name": "名称",
          "withModels": "有型号的",
          "logoBlank": "无标志"
        },
        "supporterContributions": {
          "name": "按名称搜索",
          "recurring": "周期性",
          "anonymous": "匿名",
          "startedAtGteq": "开始日期不早于",
          "startedAtLteq": "开始日期不晚于",
          "user": "关联账户",
          "linked": "账户关联",
          "linkedOnly": "已关联",
          "linkedVia": "关联方式",
          "unlinkedOnly": "未关联",
          "sourceStated": "已注明平台",
          "sourceStatedOnly": "已注明平台",
          "sourceUnspecifiedOnly": "未注明平台",
          "source": "来源"
        },
        "adminNotifications": {
          "search": "搜索"
        },
        "images": {
          "model": "飞船"
        },
        "users": {
          "search": "搜索",
          "username": "用户名",
          "email": "电子邮件",
          "rsiHandle": "RSI 用户名"
        },
        "fleets": {
          "name": "名称",
          "fid": "FID",
          "member": "成员",
          "members": {
            "role": "角色",
            "state": "状态",
            "acceptedAtGt": "Joined from",
            "acceptedAtLt": "Joined until",
            "invitedAtGt": "Invited from",
            "invitedAtLt": "Invited until",
            "requestedAtGt": "Requested from",
            "requestedAtLt": "Requested until",
            "declinedAtGt": "Declined from",
            "declinedAtLt": "Declined until"
          },
          "inviteUrls": {
            "expiresAfter": "Expire after",
            "limit": "Max number of uses"
          },
          "logistics": {
            "search": "搜索物品..."
          }
        },
        "manufacturer": "制造商",
        "commodities": {
          "description": "描述",
          "traded": "有地方交易",
          "name": "Name",
          "commodityType": "Commodity Type",
          "uexCode": "UEX Code",
          "buyPriceGt": "买入价格 >=",
          "buyPriceLt": "买入价格 <=",
          "sellPriceGt": "卖出价格 >=",
          "sellPriceLt": "卖出价格 <=",
          "storeImageBlank": "没有商店图片?"
        },
        "equipment": {
          "name": "Name",
          "equipmentType": "Equipment Type",
          "itemType": "Item Type",
          "weaponClass": "Weapon Class",
          "slot": "Slot",
          "buyPriceGt": "买入价格 >=",
          "buyPriceLt": "买入价格 <=",
          "sellPriceGt": "卖出价格 >=",
          "sellPriceLt": "卖出价格 <=",
          "storeImageBlank": "没有商店图片?"
        },
        "notifications": {
          "search": "搜索"
        },
        "blueprints": {
          "org": "发放方",
          "scKey": "游戏键名",
          "withKnownSource": "有已知来源",
          "withCraftable": "产出在目录中",
          "currentVersion": "在当前版本中",
          "name": "搜索蓝图",
          "craftableType": "产出",
          "source": "来源",
          "withSource": "有已知来源",
          "withoutSource": "无已知来源",
          "alignment": "来源阵营",
          "material": "使用材料",
          "ownedFilter": "已拥有",
          "owned": "已拥有",
          "notOwned": "未拥有"
        },
        "missions": {
          "name": "搜索任务",
          "org": "发布方",
          "standing": "声望",
          "rewarding": "奖励",
          "alignment": "阵营立场",
          "kind": "类型",
          "releasedFilter": "正式版",
          "released": "在正式版中",
          "unreleased": "未在正式版"
        }
      },
      "station": {
        "docks": "停靠口",
        "location": "位置",
        "type": "类型",
        "shops": "商店",
        "locationPrefix": {
          "default": "on",
          "orbit": "in orbit around"
        }
      },
      "tradeRoutes": {
        "buy": "Buy for: %{uec}",
        "sell": "Sell for: %{uec}"
      },
      "hardpoints": {
        "prefix": "使用以下工具试用配置",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer",
        "metricsCredit": "数据基于以下网站的计算公式"
      },
      "scunpacked": {
        "prefix": "Loadouts based on Gamefiles powered by",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "选择飞船"
      },
      "table": {
        "selected": "%{count} 已选择"
      },
      "commodityPrice": {
        "item": "ShopCommodity",
        "price": "价格",
        "type": "类型",
        "shop": "商店"
      },
      "syncExtension": {
        "warnings": "警告",
        "status": {
          "started": "导入已开始...",
          "finished": "导入完成",
          "failed": "导入失败!"
        },
        "processSteps": {
          "fetchHangar": "正在从 RSI 机库获取数据",
          "submitData": "正在提交数据到 Fleetyards.net 后台"
        },
        "sessionStatus": "RSI 会话状态",
        "checkIdentity": "检查 RSI 会话",
        "targetGroup": "找到的飞船归入的分组",
        "addBundledVehicles": "添加附带的小型飞船",
        "addBundledVehiclesHint": "添加飞船附带的小型飞船。已在机库中的会保留。",
        "unmatchedVehiclesAction": "不在 RSI 机库中的飞船",
        "unmatchedVehiclesActionHint": "如何处理这里有、但同步在你的 RSI 认购清单中找不到的飞船。",
        "unmatchedHangarGroup": "归入的分组",
        "unmatchedHangarGroupHint": "飞船保持原样，只是收集到这个分组里，方便你逐一处理。",
        "unmatchedVehiclesActions": {
          "wishlist": "移至愿望清单",
          "delete": "删除",
          "keep": "保持不变",
          "group": "归入一个分组"
        },
        "identityStatus": {
          "pending": "检查中...",
          "notFound": "未找到",
          "connected": "已连接"
        },
        "platforms": {
          "chrome": "Google Chrome or Chromium based Browsers",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "页面",
          "all": "所有质押物品",
          "ships": "飞船",
          "components": "模块",
          "upgrades": "升级"
        },
        "importedItems": {
          "importedVehicles": "已添加飞船",
          "foundVehicles": "找到的飞船",
          "movedVehiclesToWanted": "飞船已移至愿望清单",
          "deletedVehicles": "已删除的飞船",
          "groupedVehicles": "已归入分组的飞船",
          "unchangedVehicles": "保持不变的飞船",
          "missingModels": "未找到飞船",
          "importedComponents": "已添加组件",
          "foundComponents": "找到的组件",
          "missingComponents": "未找到组件",
          "missingComponentVehicles": "未找到匹配的飞船用于组件",
          "importedUpgrades": "已添加升级",
          "foundUpgrades": "找到的升级",
          "missingUpgrades": "未找到升级",
          "missingUpgradeVehicles": "未找到匹配的飞船用于升级"
        }
      },
      "cargoGridViewer": {
        "capacity": "容量",
        "maxContainerSize": "最大集装箱",
        "packed": "已装载",
        "totalCargo": "总货物",
        "didNotFit": "放不下",
        "enoughShips": "四艘飞船已填满网格。",
        "addShip": "添加飞船",
        "removeShip": "Remove",
        "autoFillShip": "Auto-fill"
      },
      "travelTimes": {
        "quantumDrive": "量子引擎",
        "fuelUsage": "燃料消耗",
        "travelTime": "旅行时间",
        "poweredBy": "基于",
        "rank": "#",
        "size": "尺寸",
        "grade": "等级",
        "sizeValue": "S%{size}",
        "intro": "每台量子引擎完成这次跃迁需要多久——以及消耗多少量子燃料。",
        "jumpDistance": "跃迁距离",
        "distanceHint": "1 Mkm 即一百万公里。横穿斯坦顿约需 40。",
        "filters": "筛选",
        "resetFilters": "重置",
        "barLegend": "长条表示相对最慢引擎的时间",
        "count": "%{count} 台引擎",
        "countFiltered": "%{total} 台中的 %{count} 台",
        "noMatch": "没有引擎符合这些筛选条件。",
        "presets": {
          "moon": "月球距离",
          "short": "短距跃迁",
          "system": "横穿斯坦顿",
          "far": "长途"
        }
      },
      "admin": {
        "blueprints": {
          "status": {
            "sourceKnown": "来源已知",
            "outputResolved": "产出在目录中"
          },
          "columns": {
            "source": "来源",
            "output": "产出",
            "build": "版本",
            "created": "创建于",
            "slot": "槽位",
            "material": "材料",
            "type": "类型",
            "quantity": "数量",
            "minQuality": "最低品质",
            "stat": "属性",
            "change": "变化",
            "base": "基准",
            "ramp": "曲线",
            "kind": "类别",
            "org": "组织",
            "mission": "任务",
            "standing": "声望",
            "pool": "奖励池"
          },
          "makes": "产出",
          "noOutput": "不在任何目录中",
          "slug": "Slug",
          "scKey": "游戏键名",
          "scRef": "游戏引用",
          "build": "版本",
          "state": "状态",
          "states": {
            "current": "当前",
            "retired": "已移除"
          },
          "createdAt": "创建于",
          "updatedAt": "更新于"
        },
        "missions": {
          "unnamed": "游戏从未命名",
          "slug": "Slug",
          "scKey": "游戏键",
          "scRef": "游戏引用",
          "generator": "生成器",
          "debugName": "调试名称",
          "build": "版本",
          "difficultyAxes": "难度（技巧 / 负担 / 风险 / 理解）",
          "state": "状态",
          "states": {
            "retired": "已移除",
            "released": "在正式版",
            "unreleased": "未在正式版"
          },
          "columns": {
            "released": "在正式版",
            "generator": "生成器",
            "build": "版本",
            "rewardKind": "类型",
            "amount": "数量",
            "rewardDetail": "详情"
          },
          "filters": {
            "debugName": "调试名称",
            "named": "已命名",
            "unnamed": "从未命名",
            "namedFilter": "命名",
            "currentBuild": "仅当前版本",
            "anyBuild": "任意版本",
            "build": "版本"
          }
        },
        "dashboard": {
          "quickStats": {
            "onlineUsers": "在线用户"
          }
        },
        "supporterContributions": {
          "source": {
            "patreon": "Patreon",
            "kofi": "Ko-fi",
            "buymeacoffee": "Buy me a coffee",
            "paypal": "PayPal",
            "other": "其他"
          },
          "linkedVia": {
            "patreon_account": "Patreon 账户",
            "claim_key": "支持者令牌",
            "payer_email": "付款人邮箱",
            "manual": "管理员设置"
          }
        },
        "announcements": {
          "columns": {
            "title": "标题",
            "status": "状态",
            "deliveries": "渠道",
            "recipients": "接收人数",
            "publishedAt": "发送时间"
          },
          "statuses": {
            "draft": "草稿",
            "scheduled": "已排期",
            "publishing": "发送中",
            "published": "已发送",
            "failed": "失败"
          },
          "channels": {
            "in_app": "应用内",
            "discord": "Discord",
            "bluesky": "Bluesky",
            "x": "X.com"
          },
          "deliveryStatuses": {
            "pending": "待处理",
            "succeeded": "已发送",
            "skipped": "已跳过",
            "failed": "失败"
          },
          "lastTested": "上次测试 %{time}",
          "noChannel": "至少选择一个渠道。",
          "notifyUsersInfo": "仅已开启的人收到邮件。",
          "discordPartsInfo": "留空：自动拆分。",
          "socialPartsInfo": "留空：一条帖子，超长截断。两条以上：话题串。",
          "recipientsCount": "%{count} 位收件人",
          "partPosition": "第 %{position} / %{total} 条"
        },
        "resourceAccess": {
          "title": "资源权限",
          "groups": {
            "ship_data": "飞船数据",
            "community": "社区",
            "system": "系统"
          },
          "privileges": {
            "blueprints": "蓝图",
            "models": "型号",
            "model_modules": "型号模块",
            "components": "组件",
            "manufacturers": "制造商",
            "vehicles": "载具",
            "images": "图片",
            "fleets": "舰队",
            "users": "用户",
            "supporters": "支持者",
            "admins": "管理员",
            "announcements": "公告",
            "oauth_applications": "OAuth 应用",
            "maintenance": "维护",
            "imports": "导入",
            "features": "功能",
            "workers": "工作进程",
            "pghero": "PgHero",
            "rsi-api-status": "RSI API 状态",
            "stats": "统计"
          }
        },
        "versions": {
          "blank": "空",
          "revertQuestion": "要还原吗?",
          "sources": {
            "custom": "管理员",
            "rsi_loader": "Ship Matrix",
            "sc_data_loader": "游戏文件",
            "sc_loader": "游戏文件",
            "uex_price_sync": "UEX 价格同步",
            "unknown": "未知"
          }
        },
        "models": {
          "unlisted": "未收录"
        }
      },
      "hangarTable": {
        "extraColumns": "列",
        "columns": {
          "storeImage": "图片",
          "storeImageWide": "宽图片",
          "angledView": "3D 图片",
          "angledViewWide": "宽 3D 图片",
          "modelManufacturerName": "制造商",
          "modelLength": "长度",
          "modelBeam": "宽度",
          "modelHeight": "高度",
          "modelMass": "质量",
          "modelCargo": "货物",
          "modelMinCrew": "船员",
          "modelMaxCrew": "最多船员",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "最大速度",
          "modelGroundMaxSpeed": "地面速度",
          "modelFocus": "定位",
          "modelProductionStatus": "生产状态",
          "modelPrice": "价格",
          "modelPledgePrice": "质押价格"
        }
      },
      "fleetTable": {
        "extraColumns": "列",
        "columns": {
          "storeImage": "图片",
          "storeImageWide": "宽图片",
          "angledView": "3D 图片",
          "angledViewWide": "宽 3D 图片",
          "modelManufacturerName": "制造商",
          "modelLength": "长度",
          "modelBeam": "宽度",
          "modelHeight": "高度",
          "modelMass": "质量",
          "modelCargo": "货物",
          "modelMinCrew": "船员",
          "modelMaxCrew": "最多船员",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "最大速度",
          "modelGroundMaxSpeed": "地面速度",
          "modelProductionStatus": "生产状态",
          "modelPrice": "价格",
          "modelPledgePrice": "质押价格",
          "owner": "所有者"
        }
      },
      "logistics": {
        "inventoryCount": "inventories",
        "pending": "pending",
        "entriesCount": "entries",
        "managedBy": "Managed by",
        "itemName": "Name",
        "category": "Category",
        "component": "Component",
        "componentCategory": "Component Type",
        "commodity": "Commodity",
        "commodityType": "Commodity Type",
        "equipment": "Equipment",
        "equipmentItemType": "Equipment Type",
        "quantity": "Quantity",
        "unit": "Unit",
        "notes": "Notes",
        "status": "Status",
        "requested": "Requested",
        "description": "Description",
        "priority": "Priority",
        "requestedBy": "Requested by",
        "states": {
          "draft": "Draft",
          "submitted": "Submitted",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "requestTypes": {
          "general": "General"
        },
        "priorities": {
          "standard": "Standard",
          "critical": "Critical"
        },
        "searchItems": "Search items...",
        "quality": "Quality (0-1000)",
        "qualityMin": "Quality >=",
        "qualityMax": "Quality <=",
        "existingItem": "Select existing item",
        "inventoryName": "Inventory Name",
        "visibility": "Visibility",
        "visibilities": {
          "members_only": "All Members",
          "officers_only": "Officers Only"
        },
        "inventory": "Inventory",
        "notesPlaceholder": "Add notes...",
        "entryType": "Type",
        "entryTypes": {
          "deposit": "Deposit",
          "withdrawal": "Withdrawal"
        },
        "stockView": "Current Stock",
        "logView": "Transaction Log",
        "addedBy": "Logged by",
        "member": "Member",
        "selectItem": "Select item",
        "currentStock": "Available",
        "location": "Location",
        "image": "Image",
        "categories": {
          "commodity": "Commodity",
          "component": "Component",
          "weapon": "Weapon",
          "equipment": "Equipment",
          "ammunition": "Attachments & Ammunition",
          "consumable": "Consumable",
          "other": "Other"
        },
        "units": {
          "scu": "SCU",
          "units": "Units"
        },
        "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
        "imported": "items imported",
        "importErrors": "errors",
        "inStock": "In stock",
        "entries": "Entries",
        "lastEntry": "Last entry",
        "history": "History",
        "linkedItem": "Linked item",
        "itemUnavailable": "Not in current patch",
        "itemUnavailableHint": "The current game build no longer ships this item. Entries keep it, but it cannot be picked for new ones.",
        "qualityRange": "Quality",
        "stockItem": "Stock Item",
        "overCapacity": "超出货舱容量",
        "cargoGrid": "货舱网格",
        "shipInventory": "飞船库存",
        "remaining": "剩余",
        "unmeasured": "%{count} 项尚未测量",
        "transferTarget": "接收方",
        "transferNote": "备注",
        "noStock": "没有可移动的物品",
        "overStock": "超过该条目的库存",
        "incoming": "接收",
        "outgoing": "发出",
        "transferStates": {
          "pending": "等待中",
          "completed": "已送达",
          "declined": "已拒绝",
          "cancelled": "已撤回",
          "expired": "已过期"
        },
        "acceptInto": "接收至",
        "reportReason": "原因",
        "reportReasons": {
          "spam": "垃圾信息",
          "harassment": "骚扰",
          "scam": "诈骗",
          "other": "其他"
        },
        "transferToFleet": "%{fleet}（舰队）",
        "sender": "来自",
        "recipient": "发往",
        "contents": "内容",
        "state": "状态",
        "sentAt": "发送时间",
        "transferKinds": {
          "inventory": "我的库存",
          "fleet": "舰队",
          "user": "某人",
          "mine": "我的库存",
          "fleetInventories": "该舰队"
        },
        "transferTargetKind": "发送至",
        "transferFromFleet": "来自舰队",
        "noTransferTargets": "这里没有可发送的目标",
        "recordedAt": "记录时间",
        "origin": "来自 / 发往",
        "inTransitAmount": "%{amount} 运送中",
        "inTransitHint": "已随一笔尚未被答复的转移送出，已不计入上方总数。",
        "transferFromFriends": "我的好友",
        "towardsContract": "计入合约",
        "noContract": "不计入合约",
        "forContract": "用于"
      },
      "hangarInventories": "Inventories",
      "adminNotifications": {
        "inbox": "收件箱",
        "archive": "归档",
        "unreadOnly": "仅未读",
        "status": "状态",
        "severity": "严重程度",
        "type": "类型",
        "selectPrompt": "选择一条通知以阅读",
        "noBody": "此通知没有更多详情。",
        "lastSeen": "最后出现",
        "expires": "过期时间",
        "severities": {
          "info": "信息",
          "warning": "警告",
          "error": "错误"
        },
        "types": {
          "paints_import": "涂装导入",
          "modules_import": "模块导入",
          "loaner_sync": "借用船同步",
          "uex_prices_import": "UEX 价格同步",
          "uex_commodity_prices_import": "UEX 商品同步",
          "uex_component_prices_import": "UEX 部件同步",
          "new_supporter": "新支持者",
          "rsi_api_blocked": "RSI API 被封锁",
          "rsi_api_unblocked": "RSI API 已恢复",
          "weekly_stats": "每周报告",
          "ship_matrix_import": "Ship Matrix 导入",
          "sc_data_import": "sc_data 导入",
          "sc_data_unlisted_models": "未收录飞船",
          "import_run": "导入",
          "oauth_application_review": "OAuth 应用审核",
          "inventory_transfer_reports": "被举报的库存转移"
        }
      },
      "optional": "可选",
      "notificationActions": {
        "open": "打开",
        "openHangar": "打开机库",
        "openWishlist": "打开愿望清单",
        "openModel": "查看飞船",
        "openInvite": "查看邀请",
        "reviewRequest": "审核申请",
        "openMembers": "查看成员",
        "openFleet": "打开舰队",
        "openInventory": "打开库存",
        "openEvent": "打开活动",
        "openRoster": "查看报名",
        "addToCalendar": "添加到日历",
        "openStore": "质押商店",
        "accept": "接受",
        "decline": "拒绝",
        "signUp": "报名",
        "withdraw": "取消报名",
        "syncAgain": "再次同步",
        "markAsBought": "标记为已购买",
        "unavailable": "此内容已不再可用。",
        "openTransfers": "打开转移",
        "openFriends": "打开好友",
        "openAllies": "打开盟友",
        "openTour": "打开行程",
        "openContract": "打开合约"
      },
      "notificationTypes": {
        "channels": {
          "app": "应用",
          "mail": "邮件",
          "push": "推送",
          "discord": "Discord"
        },
        "groups": {
          "account": "账户与机库",
          "announcements": "公告",
          "fleetMembership": "舰队成员资格",
          "fleetEvents": "舰队活动",
          "logistics": "物流",
          "relationships": "好友与盟友",
          "tours": "行程",
          "fleetContracts": "舰队合约"
        },
        "announcement": "公告",
        "hangar_create": "添加到机库",
        "hangar_destroy": "从机库移除",
        "hangar_sync_finished": "机库同步完成",
        "hangar_sync_failed": "机库同步失败",
        "wishlist_create": "添加到愿望清单",
        "wishlist_destroy": "从愿望清单移除",
        "model_on_sale": "型号特价销售",
        "new_model": "新型号发布",
        "fleet_invite": "收到舰队邀请",
        "fleet_member_requested": "收到加入申请",
        "fleet_member_accepted": "成员申请已通过",
        "fleet_request_accepted": "加入申请已通过",
        "fleet_inventory_item_added": "舰队库存新增物品",
        "fleet_event_published": "活动已发布",
        "fleet_event_locked": "活动报名已锁定",
        "fleet_event_starting_soon": "活动即将开始",
        "fleet_event_started": "活动已开始",
        "fleet_event_completed": "活动已完成",
        "fleet_event_cancelled": "活动已取消",
        "fleet_event_signup_added": "新增报名",
        "fleet_event_signup_withdrawn": "报名已取消",
        "fleet_event_signup_confirmed": "报名已确认",
        "fleet_event_signup_assigned": "已分配席位",
        "fleet_event_signup_kicked": "已被移出席位",
        "allInGroup": "此分组中的全部",
        "inventory_transfer_received": "收到转移",
        "inventory_transfer_resolved": "转移已答复",
        "friend_request_received": "收到好友请求",
        "friend_request_accepted": "好友请求已通过",
        "fleet_ally_request_received": "收到结盟请求",
        "fleet_ally_request_accepted": "结盟请求已通过",
        "tour_join_request_received": "收到参加申请",
        "tour_join_request_accepted": "参加申请已通过",
        "fleet_contract_published": "合约已发布",
        "fleet_contract_claimed": "合约已接取",
        "fleet_contract_crew_requested": "有人想加入合约",
        "fleet_contract_crew_answered": "合约成员申请已处理",
        "fleet_subscription_started": "已获得舰队功能",
        "fleet_subscription_ended": "已失去舰队功能",
        "fleet_contract_fulfilled": "合约已完成"
      },
      "fleets": {
        "missions": {
          "untitled": "未命名任务",
          "title": "标题",
          "description": "描述",
          "team": "小队",
          "teams": "小队",
          "ship": "飞船",
          "ships": "飞船",
          "slot": "席位",
          "slots": "席位",
          "noTeams": "尚未添加小队。",
          "noShips": "尚未添加飞船。",
          "noSlots": "尚未添加席位。",
          "archivedTab": "已归档",
          "activeTab": "进行中",
          "archived": "已归档",
          "modelSpecific": "指定飞船",
          "modelList": "以下任意一种",
          "modelListHint": "该席位接受您所选飞船中的任意一种。",
          "allowedShips": "符合条件的飞船",
          "anyOf": "任意一种",
          "filterRange": "筛选范围",
          "classification": "分类",
          "focus": "定位",
          "minSize": "最小尺寸",
          "maxSize": "最大尺寸",
          "minCrew": "最少船员",
          "minCrewOverride": "覆盖",
          "minCrewOverrideLabel": "最少船员覆盖值",
          "minCrewOverrideHint": "留空则使用该飞船的默认最少船员数。",
          "minCargo": "最小货舱（SCU）",
          "createdBy": "创建者",
          "seats": "座位",
          "category": "分类",
          "coverImage": "封面图片",
          "scenario": "场景",
          "categories": {
            "other": "其他",
            "ship_combat": "飞船战斗",
            "ground_combat": "地面战斗",
            "combined_combat": "联合作战",
            "mining": "采矿",
            "salvage": "回收",
            "cargo_hauling": "货运",
            "exploration": "探索"
          }
        },
        "events": {
          "untitled": "未命名活动",
          "title": "标题",
          "description": "描述",
          "briefing": "简报",
          "startsAt": "开始时间",
          "endsAt": "结束时间",
          "timezone": "时区",
          "location": "活动地点",
          "meetupLocation": "集合地点",
          "visibility": "可见性",
          "maxAttendees": "最多参与人数",
          "autoLockEnabled": "自动锁定报名",
          "autoLockMinutesBefore": "开始前多少分钟锁定",
          "recurring": "重复",
          "recurringHint": "按周期自动生成此活动。成员需为每一场次单独报名。",
          "recurringSummary": "重复：%{interval}",
          "recurringUntil": "重复：%{interval}，截止 %{date}",
          "recurringForCount": "重复：%{interval}（共 %{count} 场）",
          "viewSeries": "查看系列",
          "recurrenceInterval": "重复周期",
          "recurrenceEnd": "结束",
          "recurrenceEndNever": "永不",
          "recurrenceEndOn": "指定日期",
          "recurrenceEndAfter": "指定场次后",
          "recurrenceEndOccurrences": "场次",
          "recurrence": {
            "daily": "每日",
            "weekly": "每周",
            "biweekly": "每两周",
            "monthly": "每月"
          },
          "occurrencesSection": "即将到来的场次",
          "skipOccurrence": "跳过此场次",
          "overrideOccurrence": "覆盖 %{date} 的场次",
          "overrideOccurrenceShort": "仅编辑此场",
          "overrideOccurrenceHint": "为这一场次单独覆盖字段。留空则沿用重复活动的设置。",
          "endSeriesHere": "从此场起停止",
          "excludedBadge": "已跳过",
          "noUpcomingOccurrences": "未来 12 周内没有即将到来的场次。",
          "endSeriesConfirm": "要在此日期之后停止重复吗? 将不再生成后续场次。",
          "skipOccurrenceSuccess": "场次已跳过。",
          "endSeriesSuccess": "系列已从该日期起结束。",
          "cancelledReason": "取消原因",
          "createdBy": "创建者",
          "signups": "报名",
          "signupsCount": "%{count} 人报名",
          "youAreHere": "您在这里",
          "attendance": "出席",
          "signupsLockedHint": "此活动的报名已锁定。",
          "alreadySignedUpHint": "您已报名了另一个席位。请先取消报名再切换。",
          "slotTakenHint": "此席位已被占用。",
          "currentSlot": "当前席位",
          "currentSlotHint": "这是该报名当前所在的席位。",
          "takenBy": "已由 %{username} 占用",
          "slotPickerHint": "为此报名选择一个席位。已被占用或不可用的席位无法选择。",
          "signupCtaHint": "报名参加此活动 — 您可以现在就选择具体席位，或稍后由管理员为您分配。",
          "noSlotYet": "尚无席位",
          "signupApproval": "报名审批",
          "signupStatuses": {
            "confirmed": "已确认",
            "tentative": "待定",
            "interested": "感兴趣",
            "pending": "待审批",
            "withdrawn": "已取消"
          },
          "signupApprovals": {
            "direct": "直接通过",
            "confirmation_required": "需要确认"
          },
          "unassignedSignupsHint": "这些成员已报名活动，但尚未分配席位。请在下方为他们分配席位或移除报名。",
          "taken": "已占用",
          "grantedRoles": "已授予的角色",
          "noEventAdminsYet": "尚无其他管理员或协管员。",
          "creator": "活动创建者",
          "eventTeamHint": "为其他成员授予此活动的管理员或协管员权限。管理员可以编辑活动，协管员可以管理报名。",
          "eventRole": "角色",
          "eventRoles": {
            "admin": "管理员",
            "moderator": "协管员"
          },
          "memberPicker": "成员",
          "spawnedEvents": "已生成的活动",
          "fromMission": "来自任务",
          "pickTemplate": "选择模板",
          "changeTemplate": "更换模板",
          "clearTemplate": "清除模板",
          "myVehicle": "我的载具",
          "selectVehicle": "选择载具（可选）",
          "vehicleMismatchHint": "所选载具不符合此席位的要求。",
          "noFittingInHangar": "您的机库中没有符合此席位的载具。您仍然可以不选择载具直接报名。",
          "vehicleFitsHint": "将带来一艘符合此飞船要求的载具。",
          "notes": "备注",
          "upcomingTab": "即将到来",
          "pastTab": "已过去",
          "archivedTab": "已归档",
          "listTab": "列表",
          "calendarTab": "日历",
          "subscribeHint": "将日历订阅源 URL 复制到剪贴板，以便粘贴到您的日历应用中。",
          "visibilities": {
            "members": "成员",
            "officers": "军官",
            "fleet": "公开"
          },
          "statuses": {
            "draft": "草稿",
            "open": "报名开放中",
            "locked": "报名已锁定",
            "active": "进行中",
            "completed": "已完成",
            "cancelled": "已取消",
            "past": "已过去"
          },
          "tabs": {
            "basic": "基本信息",
            "description": "描述与封面",
            "teams": "小队与飞船",
            "overview": "概览",
            "settings": "设置"
          },
          "calendar": {
            "month": "月",
            "week": "周",
            "weekTitle": "%{date} 所在周"
          },
          "repeats": "重复"
        },
        "contracts": {
          "tabs": {
            "details": "详情",
            "delivery": "运送",
            "crew": "船员与报酬",
            "goods": "货物"
          },
          "title": "标题",
          "description": "描述",
          "reward": "报酬",
          "deadline": "截止时间",
          "crewLimit": "队伍上限",
          "reimburseExpenses": "报销开支",
          "from": "取货地点",
          "to": "交付地点",
          "lead": "负责人",
          "pendingCrew": "等待加入",
          "minQuality": "最低品质 %{value}",
          "pickedUp": "已取 %{quantity}",
          "itemName": "物品",
          "itemCategory": "类别",
          "itemUnit": "单位",
          "itemQuantity": "数量",
          "kind": {
            "label": "类型",
            "transport": "运输",
            "procurement": "采购",
            "crafting": "制造"
          },
          "state": {
            "draft": "草稿",
            "open": "开放",
            "in_progress": "进行中",
            "fulfilled": "已完成",
            "cancelled": "已取消",
            "expired": "已过期"
          },
          "itemTypes": {
            "Commodity": "商品",
            "Component": "部件",
            "Equipment": "装备"
          },
          "qualityMatch": "匹配方式",
          "exactQuality": "正好 %{value}",
          "qualityMatches": {
            "at_least": "至少",
            "exact": "正好"
          },
          "itemQuality": "品质",
          "titleHint": "可选——不填时合约以所需货物命名",
          "postedBy": "发布者",
          "claimedBy": "接下者",
          "delivered": "已交付",
          "deliveredOf": "%{delivered} / %{requested} %{unit}",
          "views": {
            "open": "进行中",
            "closed": "已结束",
            "mine": "我的",
            "completed": "已完成"
          }
        }
      },
      "commodity": {
        "name": "名称",
        "buyPrice": "买入",
        "sellPrice": "卖出",
        "retired": "已不在当前版本中",
        "containerSizes": "货柜尺寸（SCU）",
        "pieceVolume": "每件体积（SCU）",
        "consumable": "可消耗",
        "refinesInto": "精炼为",
        "availability": {
          "retired": "价格仅针对目录所在的版本记录，而该商品不在其中。",
          "craftedOnly": "没有终端交易此商品 —— 它是一种制造材料。",
          "none": "我们所知的终端都不买卖此商品。"
        },
        "chart": {
          "buyHighest": "买入，最高",
          "buyAverage": "买入，平均",
          "buyLowest": "买入，最低",
          "sellHighest": "卖出，最高",
          "sellAverage": "卖出，平均",
          "sellLowest": "卖出，最低"
        },
        "types": {
          "agricultural_supply": "农业物资",
          "alloy": "合金",
          "consumer_goods": "消费品",
          "drink": "饮品",
          "food": "食品",
          "gas": "气体",
          "hpmc": "HPMC",
          "manmade": "人造物",
          "medical_supply": "医疗物资",
          "metal": "金属",
          "military_supply": "军用物资",
          "mineral": "矿物",
          "natural": "天然物",
          "nonmetals": "非金属",
          "plasma_fuel": "等离子燃料",
          "processed_goods": "加工品",
          "quantum_fuel": "量子燃料",
          "rmc": "RMC",
          "scrap": "废料",
          "vice": "违禁品",
          "waste": "废弃物"
        },
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "equipment": {
        "equipmentType": "Equipment Type",
        "itemType": "Item Type",
        "subType": "Sub Type",
        "weaponClass": "Weapon Class",
        "slot": "Slot",
        "size": "Size",
        "grade": "Grade",
        "hidden": "Hidden?",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "notifications": {
        "inbox": "收件箱",
        "archive": "归档",
        "unreadOnly": "仅未读",
        "status": "状态",
        "type": "类型",
        "selectPrompt": "选择一条通知以阅读",
        "noBody": "此通知没有更多详情。",
        "archivesOn": "移至归档",
        "deletesOn": "删除"
      },
      "unlistedModel": {
        "linkHint": "%{identifier} 对应目录中的哪艘飞船？建议来自导出数据，可能有误。"
      },
      "slug": "Slug",
      "inventories": {
        "source": "来源",
        "sources": {
          "vehicle": "飞船",
          "handMade": "手动创建"
        }
      },
      "inventoryItems": {
        "name": "名称",
        "category": "分类",
        "entryType": "记录类型",
        "quantity": "数量",
        "quality": "品质",
        "notes": "备注",
        "itemType": "目录",
        "categories": {
          "commodity": "商品",
          "component": "组件",
          "weapon": "武器",
          "equipment": "装备",
          "ammunition": "弹药",
          "consumable": "消耗品",
          "other": "其他"
        },
        "entryTypes": {
          "deposit": "入库",
          "withdrawal": "出库"
        },
        "units": {
          "scu": "SCU",
          "units": "件"
        }
      },
      "shipHistory": {
        "sales": "促销历史",
        "salesCount": "记录的促销",
        "lastSale": "最近一次促销",
        "averageGap": "平均间隔",
        "days": "%{count} 天",
        "ongoing": "进行中",
        "priceHistory": "现金购买价历史",
        "firstPriced": "首次定价",
        "priceRemoved": "价格已移除",
        "wishlist": "每月心愿单新增",
        "patchChanges": "更新改动",
        "notRecordedYet": "仅从开始记录之日起统计，因此飞船可能尚无记录。"
      },
      "buildCompare": {
        "from": "起始版本",
        "to": "目标版本",
        "appeared": "新增",
        "vanished": "移除",
        "changed": "变更",
        "notRecorded": "其中一个版本没有记录该目录。",
        "needsTwoBuilds": "只记录了一个版本，无法进行对比。",
        "pickTwoBuilds": "请选择两个不同的版本。",
        "failed": "无法对比这两个版本。",
        "andMore": "还有 %{count} 项",
        "catalogues": {
          "components": "部件",
          "equipment": "装备",
          "commodities": "商品",
          "models": "舰船"
        }
      },
      "dockAccess": {
        "ramp": "坡道",
        "lift": "升降机",
        "tractor_beam": "牵引光束"
      },
      "dockTypes": {
        "vehiclepad": "载具停放位",
        "garage": "车库",
        "landingpad": "停机坪",
        "dockingport": "对接口",
        "hangar": "机库",
        "cargogrid": "货运格栅"
      },
      "payouts": {
        "amount": "金额",
        "description": "说明",
        "entryType": "类型",
        "expense": "支出",
        "income": "收入",
        "participant": "谁",
        "notes": "备注",
        "occurredAt": "时间",
        "paid": "支出",
        "held": "持有",
        "share": "应得",
        "net": "余额",
        "profit": "利润",
        "totalIncome": "收入",
        "totalExpenses": "支出",
        "guest": "访客",
        "username": "用户名",
        "name": "名称",
        "sends": "支付给",
        "receives": "收取",
        "settled": "已结算",
        "open": "进行中",
        "owes": "应付",
        "isOwed": "应收",
        "even": "已结清",
        "title": "标题",
        "fleet": "舰队",
        "startsAt": "开始于",
        "inviteLink": "邀请链接",
        "participants": "人数",
        "weight": "权重",
        "shares": "份",
        "customWeight": "自定义权重",
        "preview": "预览 · 结算前会变动",
        "joinRequestPending": "申请待处理"
      },
      "shipSizes": {
        "extra_extra_small": "斯努布克拉夫特 (XXS)",
        "extra_small": "特小号 (XS)",
        "small": "小型(S)",
        "medium": "中号 (M)",
        "large": "大号（L）",
        "extra_large": "特大号 (XL)",
        "capital": "资本（C）"
      },
      "relationships": {
        "party": "名称",
        "since": "自",
        "tabs": {
          "accepted": "已建立",
          "incoming": "收到的",
          "outgoing": "已发送",
          "ignored": "已忽略"
        },
        "user": {
          "handle": "用户名"
        },
        "fleet": {
          "handle": "舰队标识"
        },
        "requested": "请求已发送",
        "friend": "已是好友"
      },
      "blueprint": {
        "name": "名称",
        "craftTime": "制造时间",
        "slots": "槽位",
        "materials": "材料",
        "quality": "品质",
        "missionSlots": {
          "location": "地点",
          "objects": "目标物",
          "target": "目标",
          "ship": "飞船",
          "cargo": "货物",
          "rank": "等级",
          "danger": "危险度",
          "contract": "合约",
          "other": "可变"
        },
        "missionSlotsHint": "‹尖括号› 内的内容由游戏在提供合约时填入。",
        "atNeutral": "Q500 时为 %{value}",
        "whatYouGet": "成品属性",
        "fromSlots": "%{count} 个槽位",
        "factorOnly": "仅系数 — 目录中无该属性数值",
        "heldIn": "存于",
        "heldOn": "存于",
        "fromHangar": "机库",
        "makesA": "制造蓝图 · 产出",
        "makesUnknown": "制造蓝图 · 产出物不在任何目录中",
        "retired": "已移除",
        "minQuality": "最低 %{quality}",
        "belowGate": "低于该槽位门槛 — 品质低于 %{quality} 的材料无法放入。",
        "unvalued": "受影响 — 游戏未给出数值",
        "noStats": "该槽位不影响任何属性 — 材料只需存在即可。",
        "noMaterials": "游戏文件未列出该蓝图的材料。",
        "setEverySlot": "设置所有槽位",
        "qualityAll": "全部槽位为 %{quality}",
        "qualityRange": "各槽位 %{from}–%{to}",
        "anyOf": "在这 %{total} 项中任选 %{count} 项",
        "scu": "%{amount} SCU",
        "pieces": "%{count}×",
        "whereItDrops": "获取途径",
        "fleetOwners": "谁能制造",
        "ownedByCount": "%{count} 人拥有",
        "sourceSummary": "%{count} 个来源 · %{orgs} 个组织",
        "unattributed": "未标明组织",
        "minPoints": "%{points} 点起",
        "noKnownSource": "无已知来源",
        "noSourceLead": "没有任务或场景会发放此蓝图。",
        "noSourceBody": "游戏文件未将其列入任何奖励池，因此无从指引。",
        "empty": "没有匹配的蓝图。",
        "craftableTypes": {
          "Component": "部件",
          "Equipment": "装备",
          "Commodity": "商品"
        },
        "alignments": {
          "lawful": "守法",
          "neutral": "中立",
          "outlaw": "非法"
        },
        "kinds": {
          "contract": "合约",
          "scenario": "场景"
        },
        "duration": {
          "hours": "%{count} 小时",
          "minutes": "%{count} 分",
          "seconds": "%{count} 秒"
        }
      },
      "gameMission": {
        "calculatedInGame": "由游戏计算",
        "blueprints": "蓝图",
        "name": "名称",
        "org": "发布方",
        "offeredBy": "发布方",
        "offeredByUnknown": "未注明委托方",
        "standing": "声望",
        "kind": "类型",
        "kinds": {
          "career": "职业",
          "contract": "一次性"
        },
        "difficulty": "难度",
        "difficultyAxes": {
          "mechanicalSkill": "操作技巧",
          "mentalLoad": "心智负担",
          "riskOfLoss": "损失风险",
          "gameKnowledge": "游戏理解"
        },
        "alignments": {
          "lawful": "守法",
          "neutral": "中立",
          "outlaw": "不法"
        },
        "rewards": "奖励",
        "rewardKinds": {
          "blueprint": "蓝图",
          "reputation": "声望",
          "item": "物品",
          "badge": "徽章",
          "currency": "报酬"
        },
        "oneOfASet": "一组中的一件",
        "briefing": "任务简报",
        "templatedNote": "标记的部分由游戏在发布任务时填入。",
        "payoutNote": "报酬由游戏在生成任务时计算，因此游戏文件只为少数合同写明了金额。",
        "noRewards": "游戏文件未为此任务写明奖励。",
        "unreleased": "未在正式版",
        "retired": "已移除"
      }
    }
  }
}
